import { createColumnHelper } from '@tanstack/react-table';
import { TableLink } from '@monorepo/base/src/components/table/table-link/table-link';
import { BetweenPagesStateProps } from '@monorepo/tools/src/lib/interfaces/global';
import { IMergedHeadersReturn } from './index.headers';
import { IAdminxStore } from '../../stores';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useRoute } from '../tools/use-route';
import { useEffect } from 'react';
import { parseRelatedCampaign, TrafficEntityModel } from '../../models/traffic-entity.model';
import routes from '../../routes/index.routes';

const columnHelper = createColumnHelper<TrafficEntityModel>();

export const useBidderTrafficHeaders = (): IMergedHeadersReturn<TrafficEntityModel> => {
	const { settingsStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const tableStore = settingsStore.pages.get(currentRouteWithoutSpecialChars)?.tableStore;

	useEffect(() => {
		if (tableStore && Object.keys(tableStore.getColumnVisibility()).length === 0) {
			tableStore.setDefaultColumnVisibility({
				id: true,
				geo: true,
				op_system: true,
				browser: true,
				device_type: true,
				rel_camp: true,
			});

			tableStore.setColumnVisibility(tableStore.getDefaultColumnVisibility());

			if (tableStore.getSortingBy().length === 0) {
				tableStore.setSortingBy([{ id: 'id', desc: false }]);
			}
		}
	}, [tableStore]);

	return {
		columns: [
			columnHelper.accessor('id', {
				header: 'ID',
				size: 80,
				cell: ({ row }) => (
					<TableLink
						toEdit={routes.bidder.editTraffic(String(row.original.id))}
						toEditState={{ isBlockRequest: true } as BetweenPagesStateProps}>
						{row.original.id}
					</TableLink>
				),
			}),
			columnHelper.accessor('geo', { header: 'Geo', size: 90 }),
			columnHelper.accessor('op_system', { header: 'Operating System', size: 170 }),
			columnHelper.accessor('browser', { header: 'Browser', size: 140 }),
			columnHelper.accessor('device_type', { header: 'Device Type', size: 140 }),
			columnHelper.accessor('rel_camp', {
				header: 'Related Campaigns',
				enableSorting: false,
				cell: ({ row }) => {
					const campaigns = row.original.rel_camp ?? [];
					if (campaigns.length === 0) {
						return <span>—</span>;
					}
					return (
						<div>
							{campaigns.map((entry, index) => {
								const campaign = parseRelatedCampaign(entry);
								if (!campaign.id) {
									return <div key={`${entry}-${index}`}>{campaign.name}</div>;
								}
								return (
									<TableLink key={`${entry}-${index}`} to={routes.bidder.editCampaign(campaign.id)}>
										{`${campaign.id} - ${campaign.name}`}
									</TableLink>
								);
							})}
						</div>
					);
				},
			}),
		],
	};
};
